import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Fire icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Fire } from '@sravni/design-system-icons'
 *
 * <Fire />
 * ```
 */
var Fire = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Fire", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.788 8s-4.038 4.5 3.71 9c0 0-1.022-2 0-3.394C10.837 16 12.35 17 12.35 17c8.077-4.5 2.524-11 2.524-11 0 2.545-1.514 4-1.514 4 0-5.5-5.553-7-5.553-7 1.01 5-.225 6.364-.225 6.364C6.293 9.5 5.788 8 5.788 8Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Fire };
//# sourceMappingURL=Fire.js.map
